import { render } from "./InputData.vue?vue&type=template&id=27d60572&scoped=true"
import script from "./InputData.vue?vue&type=script&lang=js"
export * from "./InputData.vue?vue&type=script&lang=js"

import "./InputData.vue?vue&type=style&index=0&id=27d60572&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/popinsight-tools/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d60572"]])

export default __exports__